import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

const UNLIIMTED_ATTEMPTS = {
  VALUE: -10,
  TEXT: "Unlimited",
};
/**
 * TotalAttempts:
 *  - Component display TotalAttempts left for Question
 */
export function TotalAttempts(props) {
  const renderTotalCount = () => {
    if (props.totalAttempts === UNLIIMTED_ATTEMPTS.VALUE) {
      return UNLIIMTED_ATTEMPTS.TEXT;
    } else {
      return props.totalAttempts;
    }
  };

  const className = `${style.attempts} ${props.className}`;

  return <span className={className}>Attempts left: {renderTotalCount()}</span>;
}

TotalAttempts.propTypes = {
  /**
   * To display total attempts
   */
  totalAttempts: PropTypes.number.isRequired,
  /**
   * ClassName for the question wrapper
   */
  className: PropTypes.string,
};

TotalAttempts.defaultProps = {
  className: "",
  totalAttempts: 0,
};
